module.exports = __webpack_public_path__ + "img/text.0638603c.gif";